"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var lodash_1 = require("lodash");
var react_router_dom_1 = require("react-router-dom");
var getState_1 = require("../../utils/getState");
var permissions_1 = require("../../../app/utils/permissions");
var QuickActions = function () {
    var user = (0, getState_1.default)().user;
    var _a = __read(React.useState(''), 2), companyName = _a[0], setCompanyName = _a[1];
    React.useEffect(function () {
        if (user === null || user === void 0 ? void 0 : user.company_name) {
            if (user.company_name.length > 30) {
                setCompanyName("".concat(user.company_name.slice(0, 20), "..."));
            }
            else {
                setCompanyName(user.company_name);
            }
        }
    }, [user === null || user === void 0 ? void 0 : user.company_name]);
    var standardClassnames = 'button quick-action-buttons';
    var activeClassnames = "active_dashboard_header ".concat(standardClassnames);
    // Only render if user is logged in
    if ((0, lodash_1.isEmpty)(user)) {
        return null;
    }
    return (React.createElement("div", { className: "quick-actions" },
        React.createElement("div", { className: "customer-items" },
            user.role === 'customer' && (React.createElement(React.Fragment, null,
                React.createElement(react_router_dom_1.NavLink, { className: function (_a) {
                        var isActive = _a.isActive;
                        return (isActive ? activeClassnames : standardClassnames);
                    }, to: "/dashboard", onClick: function () {
                        if (window.location.href.endsWith('dashboard')) {
                            window.location.reload();
                        }
                    }, end: true }, "Dashboard"),
                React.createElement(react_router_dom_1.NavLink, { className: function (_a) {
                        var isActive = _a.isActive;
                        return (isActive ? activeClassnames : standardClassnames);
                    }, to: "/dashboard/debtors" }, "Debtors"),
                React.createElement(react_router_dom_1.NavLink, { className: function (_a) {
                        var isActive = _a.isActive;
                        return (isActive ? activeClassnames : standardClassnames);
                    }, to: "/dashboard/my_company" }, "My Company"))),
            (0, permissions_1.hasPermission)(user, ['legal']) && (React.createElement(react_router_dom_1.NavLink, { className: function (_a) {
                    var isActive = _a.isActive;
                    return (isActive ? activeClassnames : standardClassnames);
                }, to: "/admin", end: true }, "Dashboard")),
            (0, permissions_1.hasPermission)(user, ['admin', 'legal']) && (React.createElement(react_router_dom_1.NavLink, { className: function (_a) {
                    var isActive = _a.isActive;
                    return (isActive ? activeClassnames : standardClassnames);
                }, to: "/admin/debts" }, "Debts")),
            (0, permissions_1.hasPermission)(user, ['admin', 'legal']) && (React.createElement(react_router_dom_1.NavLink, { className: function (_a) {
                    var isActive = _a.isActive;
                    return (isActive ? activeClassnames : standardClassnames);
                }, to: "/admin/companies" }, "Companies")))));
};
exports.default = QuickActions;
